import "./App.css";
import { Route, Routes } from "react-router-dom";
import Layout from "./Layout";
import HomePage from "./pages/Homepage";
import LoginPage from "./pages/Loginpage";
import RegisterPage from "./pages/Registerpage";
import { UserContextProvider } from "./UserContext";
import CreatePage from "./pages/CreatePage";
import ProfilePage from "./pages/ProfilePage";
import FullPage from "./pages/FullPage";
import EditPage from "./pages/EditPage";

function App() {
  return (
    <UserContextProvider>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/create" element={<CreatePage />} />
          <Route path="/profile/:id" element={<ProfilePage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/post/:id" element={<FullPage />} />
          <Route path="/edit/:id" element={<EditPage />} />
        </Route>
      </Routes>
    </UserContextProvider>
  );
}

export default App;
